import { useQuery } from "@tanstack/react-query";
import { blockedNumbersQueryKey, listBlockedNumbers } from "./blockNumber.action";

export const useBlockedNumbersQuery = (companyId?: string | number | null) => {
  return useQuery({
    queryKey: blockedNumbersQueryKey(companyId),
    queryFn: listBlockedNumbers,
    enabled: Boolean(companyId),
  });
};
